module.exports = __webpack_public_path__ + "img/mp4.a7a1e746.svg";